import Vue from 'vue';

import layoutLogin from '@/layouts/layout-login';
import layoutAdmin from '@/layouts/layout-admin';
import layoutDashboard from '@/layouts/layout-dashboard';
import generalFilter from '@/components/shared/general-filter';
import appDateMask from '@/components/shared/app-date-mask';
import appTable from '@/components/shared/table/app-table';
import appTableDisenarEscala from '@/components/shared/table-disenar-escala/app-table-disenar-escala';
import appTableDisenarEscalaHeader from '@/components/shared/table-disenar-escala/app-table-disenar-escala-header';
import appTableDisenarEscalaData from '@/components/shared/table-disenar-escala/app-table-disenar-escala-data';
import appTableDisenarEscalaOrange from '@/components/shared/table-disenar-escala/app-table-disenar-escala-orange';
import appTableDisenarEscalaOdata from '@/components/shared/table-disenar-escala/app-table-disenar-escala-Odata';
import appTableDisenarEscalaGrafico from '@/components/shared/table-disenar-escala/app-table-disenar-escala-grafico';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appBtn from '@/components/shared/app-btn';
import pNotificationBell from '@/modules/shared/components/ui/p-notification-bell';
import headerPage from '@/components/shared/header-page';
import formSidebar from '@/components/shared/form-sidebar';
import modalSidebarButton from '@/components/shared/utils/modal-sidebar-button';

Vue.component('layout-login', layoutLogin);
Vue.component('layout-admin', layoutAdmin);
Vue.component('layout-dashboard', layoutDashboard);
Vue.component('app-date-mask', appDateMask);
Vue.component('app-table', appTable);
Vue.component('app-table-disenar-escala', appTableDisenarEscala);
Vue.component('app-table-disenar-escala-header', appTableDisenarEscalaHeader);
Vue.component('app-table-disenar-escala-data', appTableDisenarEscalaData);
Vue.component('app-table-disenar-escala-orange', appTableDisenarEscalaOrange);
Vue.component('app-table-disenar-escala-Odata', appTableDisenarEscalaOdata);
Vue.component('app-table-disenar-escala-grafico', appTableDisenarEscalaGrafico);
Vue.component('app-tooltip-button', appTooltipButton);
Vue.component('app-btn', appBtn);
Vue.component('p-notification-bell', pNotificationBell);
Vue.component('header-page', headerPage);
Vue.component('general-filter', generalFilter);
Vue.component('form-sidebar', formSidebar);
Vue.component('modal-sidebar-button', modalSidebarButton);



// WEBPACK FOOTER //
// ./src/global-components.js